import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Avatar,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ShieldIcon from "@mui/icons-material/Shield";
import PersonIcon from "@mui/icons-material/Person";

const UserDetails = ({
  userDetails,
  handleResendNotification,
  handleIssueBadge,
  loading,
}) => {
  if (!userDetails) return null;

  const { name, booking_id, invite_status, kyc, badge_color, user_image } =
    userDetails;

  const userImage = user_image;

  const renderStatus = (Icon, label, status) => (
    <Box display="flex" alignItems="center" mb={2}>
      <Icon sx={{ color: "#4444ff", mr: 1 }} />
      <Typography variant="body1" sx={{ flexGrow: 1, color: "#333" }}>
        {label}
      </Typography>
      <Chip
        label={status ? "Yes" : "No"}
        size="small"
        sx={{
          bgcolor: status ? "#d1fae5" : "#fee2e2",
          color: status ? "green" : "red",
          fontWeight: "bold",
        }}
      />
    </Box>
  );

  return (
    <Grid container justifyContent="center" mt={4}>
      <Grid item xs={12} md={5} lg={4}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 4,
            background: "linear-gradient(145deg, #fffefc, #fafafa)",
            boxShadow: "0 4px 6px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.1)",
            p: 3,
          }}
        >
          {/* Badge Image */}
          <Box display="flex" flexDirection="column" alignItems="center" mt={1}>
            <Box sx={{ borderRadius: 3, p: 2, mb: 1 }}>
              <Avatar
                src={userImage}
                sx={{
                  bgcolor: badge_color,
                  width: 92,
                  height: 92,
                  fontSize: 28,
                }}
              >
                {name?.[0]}
              </Avatar>
            </Box>
            <Typography
              variant="caption"
              sx={{ letterSpacing: 1, color: "#666", fontWeight: "bold" }}
            >
              DIGITAL BADGE
            </Typography>
          </Box>

          <CardContent sx={{ textAlign: "center" }}>
            {/* Name */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={1}
            >
              <PersonIcon sx={{ mr: 1, color: badge_color }} />
              <Typography variant="h6" fontWeight="bold" color="text.primary">
                {name}
              </Typography>
            </Box>

            {/* Booking ID */}
            <Box
              sx={{
                bgcolor: "#f5f5f5",
                borderRadius: 2,
                py: 1,
                px: 2,
                mb: 3,
                display: "inline-block",
              }}
            >
              <Typography variant="caption" sx={{ color: "#666" }}>
                BOOKING ID
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
              >
                {booking_id}
              </Typography>
            </Box>

            {/* Status Rows */}
            {renderStatus(CheckCircleIcon, "Invite Status", invite_status)}
            {renderStatus(ShieldIcon, "KYC Status", kyc)}

            {/* {renderStatus(ShieldIcon, "KYC Status", kyc)} */}

            {/* Action Buttons */}
            <Grid container justifyContent="center" spacing={2} mt={2}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleIssueBadge}
                  disabled={loading}
                  sx={{
                    backgroundColor: badge_color,
                    borderRadius: 3,
                    fontWeight: "bold",
                    textTransform: "none",
                    py: 1.2,
                    "&:hover": { backgroundColor: badge_color },
                  }}
                >
                  Issue Badge
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={handleResendNotification}
                  disabled={loading}
                  sx={{
                    borderColor: badge_color,
                    color: badge_color,
                    borderRadius: 3,
                    fontWeight: "bold",
                    textTransform: "none",
                    py: 1.2,
                    "&:hover": { backgroundColor: "#fff8ef" },
                  }}
                >
                  Resend Notification
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default UserDetails;
